module.exports = __webpack_public_path__ + "static/img/banner.6d5ea9e2.jpg";